import { render, staticRenderFns } from "./RelatedArticle.vue?vue&type=template&id=0aa3837f&scoped=true&"
import script from "./RelatedArticle.vue?vue&type=script&lang=js&"
export * from "./RelatedArticle.vue?vue&type=script&lang=js&"
import style0 from "./RelatedArticle.vue?vue&type=style&index=0&id=0aa3837f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa3837f",
  null
  
)

export default component.exports